import {
  initialState,
  PendingAcceptedServicesState,
  pendingAcceptedServicesAdapter
} from './pending-accepted-services.interfaces';
import * as fromPendingAcceptedServices from './pending-accepted-services.actions';
export function reducer(
  state = initialState,
  action: fromPendingAcceptedServices.PendingAcceptedServiceAction
): PendingAcceptedServicesState {
  switch (action.type) {
    case fromPendingAcceptedServices.ADD_PENDING_ACCEPTED_SERVICE_IN_STATE: {
      return {
        ...pendingAcceptedServicesAdapter.addOne(action.payload.serviceGroup, state)
      };
    }
    case fromPendingAcceptedServices.REMOVE_PENDING_ACCEPTED_SERVICE_IN_STATE: {
      return {
        ...pendingAcceptedServicesAdapter.removeOne(action.payload.id, state)
      };
    }
    case fromPendingAcceptedServices.CLEAR_PENDING_ACCEPTED_SERVICE_IN_STATE: {
      return initialState
    }
    default: {
      return state;
    }
  }
}
